module.exports = __webpack_public_path__ + "img/bcf152d.jpg";